/**
 * @generated SignedSource<<a5203c6ff40df5139999fb4d3e3d456c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RetellingStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type SubmitRetellingInput = {
  dictation: ReadonlyArray<DictationAttempt>;
  storyPageId: string;
  text: string;
};
export type DictationAttempt = {
  attempts: number;
  page: number;
  sentence: number;
  typed: string;
};
export type ListenWriteSubmitMutation$variables = {
  input: SubmitRetellingInput;
};
export type ListenWriteSubmitMutation$data = {
  readonly submitRetelling: {
    readonly retelling: {
      readonly id: string;
      readonly status: RetellingStatus;
    };
  };
};
export type ListenWriteSubmitMutation = {
  response: ListenWriteSubmitMutation$data;
  variables: ListenWriteSubmitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitRetellingPayload",
    "kind": "LinkedField",
    "name": "submitRetelling",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Retelling",
        "kind": "LinkedField",
        "name": "retelling",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ListenWriteSubmitMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ListenWriteSubmitMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "0697dca880c76ed66d900ce54caa7ff7",
    "id": null,
    "metadata": {},
    "name": "ListenWriteSubmitMutation",
    "operationKind": "mutation",
    "text": "mutation ListenWriteSubmitMutation(\n  $input: SubmitRetellingInput!\n) {\n  submitRetelling(input: $input) {\n    retelling {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe1b3d4dc73c9db55aee70ffb145db91";

export default node;
